//CSS
import "../../Components/Page/Page.css";


//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";

//Data
import QuoteComp from "../../Components/QuoteComp/QuoteComp";

const BuisnessModel: React.FC = () => {
    return (
        <div className="sectionContainer">
            <SecHeader title="Business Model" />
            <SubSection>
                {/* <ImageComp imageSource={approach} width={"Clamp(18rem, 25vw, 36rem)"} /> */}
                <QuoteComp isQuote={true} text={"We intend to generate outstanding returns for our shareholders by selling innovative, exclusive ELF-Tech™ licenses, must have E-SPEC™ data and services, CADs, and consulting for positive disruption of the $3T/year engines industry."} />
                <div className="description-container">
                    <b>Licensing for Engine or Parts Production</b>
                    <p>
                        Core Revenue will come from production licenses’ ongoing royalties
                    </p>{" "}
                    <b>Exclusivity and Prototyping Licenses</b>
                    <p>
                        Allowing manufacturers to test and adjust our parts and assemblies to their 
                        strengths, and for time or geography exclusivities if desired.
                    </p>{" "}
                    <b>E-SPEC Data and Software</b>
                    <p>
                       E-SPEC users can explore how ELF-Tech innovations give their product the best
                        edge in power, weight, efficiency, emissions and costs. This will become the 
                        “must use” global gold standard, and it will be the only product with all the 
                        ELF-Tech design data.
                    </p>{" "}
                    <b>Engine or Parts CADs</b>
                    <p>
                        From our library of parts Computer Aided Designs (CAD)s
                    </p>{" "}
                    <b>Consulting Services</b>
                    <p>
                        From our 30-years of R&D, test engines, and assembly knowledge
                    </p>{" "}
                </div>
            </SubSection>
        </div>
    );
};

export default BuisnessModel;